import Axios from "axios";

const handleTypeUrl = "/storefront/get_handle_type";
const productListUrl = "/storefront/product_list";
const filterListUrl = "/storefront/filter_list";
const productDetailsUrl = "/storefront/product";
const relatedProductUrl = "/storefront/product/related_products";
const brandProductsUrl = "/storefront/product_list";
const storeListUrl = "/storefront/store_list";

const STOREFRONT_ID = process.env.NEXT_PUBLIC_STOREFRONT_ID || "23";
const storeListBackend =
  process.env.NEXT_PUBLIC_BACKEND_UAT ||
  "https://alfa-uat-be.comverseglobal.com";

const fashionApi = {
  getHandleType(handle, params = {}) {
    return Axios({
      url: process.env.NEXT_PUBLIC_BACKEND + handleTypeUrl,
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      data: {
        handle: handle,
        storefront: STOREFRONT_ID,
        ...params,
      },
    }).then((response) => response);
  },
  getCollectionData(params) {
    return Axios({
      url: process.env.NEXT_PUBLIC_BACKEND + productListUrl,
      method: "GET",
      params: {
        storefront: STOREFRONT_ID,
        ...params,
      },
      paramsSerializer: (p) => {
        const usp = new URLSearchParams();
        for (const [key, val] of Object.entries(p)) {
          if (Array.isArray(val)) {
            val.forEach((v) => usp.append(key, v));
          } else if (val !== undefined && val !== null) {
            usp.append(key, val);
          }
        }
        return usp.toString();
      },
    }).then((response) => response);
  },
  getFilterList(params) {
    return Axios({
      url: process.env.NEXT_PUBLIC_BACKEND + filterListUrl,
      method: "GET",
      params: {
        storefront: STOREFRONT_ID,
        ...params,
      },
      paramsSerializer: (p) => {
        const usp = new URLSearchParams();
        for (const [key, val] of Object.entries(p)) {
          if (Array.isArray(val)) {
            val.forEach((v) => usp.append(key, v));
          } else if (val !== undefined && val !== null) {
            usp.append(key, val);
          }
        }
        return usp.toString();
      },
    }).then((response) => response);
  },
  getProductDetails(handle, params) {
    return Axios({
      url: process.env.NEXT_PUBLIC_BACKEND + productDetailsUrl + `/${handle}`,
      method: "GET",
      params: {
        storefront: STOREFRONT_ID,
        ...params,
      },
    }).then((response) => response);
  },
  getRelatedProducts(handle, params) {
    return Axios({
      url: process.env.NEXT_PUBLIC_BACKEND + relatedProductUrl + `/${handle}`,
      method: "GET",
      params: {
        limit: 4,
        storefront: STOREFRONT_ID,
        ...params,
      },
    }).then((response) => response);
  },
  getBrandProducts(params) {
    return Axios({
      url: process.env.NEXT_PUBLIC_BACKEND + brandProductsUrl,
      method: "GET",
      params: {
        storefront: STOREFRONT_ID,
        ...params,
      },
    }).then((response) => response);
  },
  getStoreList(params) {
    return Axios({
      url: process.env.NEXT_PUBLIC_BACKEND + storeListUrl,
      method: "GET",
      params: {
        ...params,
      },
    }).then((response) => response);
  },
};

export default fashionApi;
